$(document).ready(function () {
  // Remove row from table on click and call action
  $(document).on('click', '.advisors-dead-lead-tracker-component .stop-tracking-button-js .padding-for-button-hover', function () {
    const parentRow = $(this).closest('tr')
    const dealId = parentRow.attr('deal_id')
    const advisorCompanyId = parentRow.closest('.clients-holder').attr('advisor_company_id')

    // Call action to update deal properties and remove track on dead lead
    $.post('/components/advisors/remove_track_on_dead_lead_skcc_and_hs', { deal_id: dealId, advisor_company_id: advisorCompanyId }).done(function (data) {
      if (data.success === false) {
        alert('Error: ' + data.errors)
        return
      }
      // If action is completed, remove row from view
      parentRow.remove()
    })
  })
})